import HttpService from 'services/HttpService';
import { TOKEN_EXPIRED, REDEMPTION_CODE_ALREADY_USED_BY_ANOTHER_USER } from './constants';
import loginEvent from 'services/AuthSuite/AuthSuiteServices/events';
import { clearAuthsuiteStorage } from 'helpers/mvpdStorage';

export function checkMvpdAssociation(httpData) {
    const http = new HttpService();
    return http
        .doGet('/aa-app-xhr/check-mvpd-association/', httpData)
        .then((res) => {
            if (res && res.data) {
                const { result } = res.data;
                return result.isUserBounded;
            }
        })
        .catch((err) => {
            loginEvent.emitFail(err);
        });
}

export function autoLoginBoundUser(httpData, redirectPath = '/', callback = null) {
    const http = new HttpService();

    http.doPost('/aa-app-xhr/login-bound-user/', httpData)
        .then((res) => {
            const { result } = res.data;
            if (result.success === true) {
                if (typeof callback == 'function') {
                    callback({ regId: result.userId, redirectPath, success: result.success });
                } else {
                    window.location.href = redirectPath;
                }
            } else if (result.success === false) {
                callback({ success: result.success, message: result.message });
            }
        })
        .catch((err) => {
            loginEvent.emitFail(err);
        });
}

export function bindWithAuthSuite(httpData, tokenCallBack) {
    const http = new HttpService();

    return http
        .doPost('/aa-app-xhr/bind-with-auth-suite/', httpData)
        .then((res) => {
            const { result, user } = res.data;
            if (result.success === true) {
                return {
                    success: result.success,
                    user,
                };
            } else {
                if (
                    result.message === TOKEN_EXPIRED ||
                    result.message === REDEMPTION_CODE_ALREADY_USED_BY_ANOTHER_USER
                ) {
                    tokenCallBack(result.message);
                }
                return false;
            }
        })
        .catch((err) => {
            loginEvent.emitFail(err);
        });
}

/**
 *
 * @param {method} callback
 */
export function unbindWithAuthSuite(callback) {
    const http = new HttpService();
    http.doPost('/aa-app-xhr/unbind-with-auth-suite/', {})
        .then((res) => {
            const { result } = res.data;
            clearAuthsuiteStorage();
            if (callback) {
                callback(result);
            }
        })
        .catch((e) => {
            // TODO: Deal with error, seperate ticket
            console.error(e);
            return false;
        });
}

export function deauthorize(callback) {
    const http = new HttpService();
    http.doPost('/aa-app-xhr/deauthorize/', {})
        .then((res) => {
            const { success } = res;
            if (callback) {
                callback(res);
            }
        })
        .catch((e) => {
            // TODO: Deal with error, seperate ticket
            console.error(e);
            return false;
        });
}

export function refreshUserAccess(httpData, successCallback, tokenCallback) {
    const http = new HttpService();
    http.doPost('/aa-app-xhr/refresh-authsuite-user-access/', httpData)
        .then((res) => {
            const { result } = res.data;
            if (result.success === true) {
                successCallback();
                return true;
            } else {
                if (result.message === TOKEN_EXPIRED) {
                    tokenCallback();
                }
                return false;
            }
        })
        .catch((e) => {
            // TODO: Deal with error, seperate ticket
            console.error(e);
            return false;
        });
}

export function getPartnerSubscriptionDetails(httpData, successCallback) {
    const http = new HttpService();
    return http
        .doPost('/aa-app-xhr/partner-subscription-details/', httpData)
        .then((res) => {
            const { result } = res.data;
            if (result.success === true) {
                successCallback(result);
                return true;
            } else {
                // Handle error codes
                return false;
            }
        })
        .catch((e) => {
            console.log(e);
            // TODO: Deal with error, seperate ticket
            // console.error(e);
            return false;
        });
}

export function bindWithPartnerAccount(httpData, successCallback) {
    const http = new HttpService();

    return http
        .doPost('/aa-app-xhr/bind-partner-account/', httpData)
        .then((res) => {
            const { result, user } = res.data;
            if (result.success === true) {
                successCallback();
                return {
                    success: result.success,
                    user,
                };
            } else {
                return res?.data?.result;
            }
        })
        .catch((e) => {
            // TODO: Deal with error, seperate ticket
            console.error(e);
            return false;
        });
}
